module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": 'row' + _vm.booking_id
    }
  }, [_c('md-switch', {
    staticClass: "md-primary",
    attrs: {
      "id": 'approval' + _vm.booking_id,
      "name": "approval",
      "value": _vm.isbookingactive == 1
    },
    on: {
      "change": function($event) {
        _vm.toggleStatus(_vm.prbr_id, _vm.prbr_is_active, _vm.booking_id, _vm.isbookingactive, _vm.request_type)
      }
    }
  }, [_c('h6', [_c('br'), _vm._v(" "), _c('b-badge', {
    staticStyle: {
      "margin-left": "-45px"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.isbookingactive == 1 ? "Active" : "In-Active") + "\n        ")])], 1)]), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64027d42","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/ToggleSwitch.vue
// module id = 2686
// module chunks = 0